import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=ed4c8cec&scoped=true&"
import script from "./Evaluate.vue?vue&type=script&lang=js&"
export * from "./Evaluate.vue?vue&type=script&lang=js&"
import style0 from "./Evaluate.vue?vue&type=style&index=0&id=ed4c8cec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c8cec",
  null
  
)

export default component.exports